import React, { useState } from 'react'
import './CSS/loginsignup.css'

const LoginSignup = () => {

  const [state, setState] = useState("Sign Up")

  const [formData, setFormData] = useState({
    username: "",
    email: "",
    password: "",
  })

  const changeHandler = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })

  }

  const logIn = async () => {
    console.log(formData,"login function")
    //
    let responseData
    await fetch('http://localhost:4000/login', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((res) => res.json())
      .then((data) => {
        responseData = data

      })

    if (responseData.success) {
      
       localStorage.setItem('auth-token',responseData.token)
       window.location.replace('/')
    }else{
      alert(responseData.errors)
    }

    //
  }

  const signUp = async () => {
    let responseData

    console.log(formData,"signup function")

    await fetch('http://localhost:4000/signup', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((res) => res.json())
      .then((data) => {
        responseData = data

      })

    if (responseData.success) {
      
       localStorage.setItem('auth-token',responseData.token)
       window.location.replace('/')
    }else{
      alert(responseData.errors)
    }

  }

 
  return (
    <div className='loginsignup'>
      <div className="loginsignup-container">
        <h1>{state}</h1>
        <div className="loginsignup-fields">
          {state == "Sign Up" ? <input type="text" placeholder='name..' name='username' value={formData.username} onChange={changeHandler} /> : <></>}
          <input type="email" placeholder='email..' name='email' value={formData.email} onChange={changeHandler} />
          <input type="password" placeholder='password..' name='password' value={formData.password} onChange={changeHandler} />
        </div>
        <button onClick={() => state == "LogIn" ? logIn() : signUp()} >Continue</button>
        {state == "Sign Up" ? <p className='login-button'>Already have an account ? <span onClick={() => setState("LogIn")} >Login </span>here</p> :
          <p className='login-button'>Create an account ? <span onClick={() => setState("Sign Up")}>Click </span>here</p>}

        <div className="loginsignup-aggre">
          <input type="checkbox" name='' id='' />
          <p>By continuing, I aggree all the terms and conditions</p>
        </div>
      </div>

    </div>
  )
}

export default LoginSignup